const applyPayload = (state, action) => ({
  ...state,
  ...action.payload,
});

export default applyPayload;
